module.exports = __webpack_public_path__ + "img/dp4.b937d1f4.png";